/* data는 REST-API 를 통해 받아옴 ( 조회조건 / 검색결과 등.. 에 따른 data) */
/* 또는 전체 데이터 개수와 목록개수(10, 15, 20 등..) 에 따른 데이터만 받아옴 */
/* 
    최초 받아야 하는 param 목록
        currentPage : 현재 / 최초 페이지 번호
        totalSize : 전체 데이터 개수(건 수)
    최초 보내줘야 하는 param 목록
        pageRange : 페이지 목록 개수
        searchKey : 검색어/검색조건
*/
const state = {
  pagingInfo: {
    totalSize: null,
    totalPage: null,
    pageRange: null,
    currentPage: null,
    pageSize: null
  },
  pageData: [],
  sliceData: []
};
const actions = {
  /* 최초 데이터 및 페이지 개수  */
  initPage({ state, commit }, context) {
    let totalSize = state.pageData.length;
    let totalPage = 0;
    let pageRange = context.pageRange;
    let currentPage = context.currentPage;
    totalPage = Math.floor(totalSize / pageRange);

    if (totalSize % pageRange > 0) {
      totalPage++;
    }
    commit("setPagingInfo", { totalSize, totalPage, pageRange, currentPage });
  },
  /* 페이징 데이터 */
  paginatedData({ state, commit }) {
    let start = (state.pagingInfo.currentPage - 1) * state.pagingInfo.pageRange;
    let end = start + state.pagingInfo.pageRange;

    commit("setListData", { start, end });
  },
  /* 첫 페이지 이동 */
  goFirstPage({ state, commit }) {
    let currentPage = 1;
    commit("setFirstPage", currentPage);
  },
  /* 이전 페이지 이동 */
  goPrevPage({ state, commit }) {
    //this.currentPage = this.currentPage - 1;
    let currentPage = state.pagingInfo.currentPage - 1;
    if (currentPage == 0) {
      alert(this.$t("message.pagingjs.001", "가장 첫 페이지 입니다."));
      return;
    } else {
      commit("setPrevPage", currentPage);
    }
  },
  /* 다음 페이지 이동 */
  goNextPage({ state, commit }) {
    let currentPage = state.pagingInfo.currentPage + 1;
    if (currentPage == state.pagingInfo.totalPage + 1) {
      alert(this.$t("message.pagingjs.002", "가장 끝 페이지 입니다."));
      return;
    } else {
      commit("setNextPage", currentPage);
    }
  },
  /* 마지막 페이지 이동 */
  goLastPage({ state, commit }) {
    let currentPage = state.pagingInfo.totalPage;
    commit("setLastPage", currentPage);
  },
  /* 선택한 페이지 이동 */
  goSelectedPage({ state, commit }, context) {
    commit("setCurrentPage", context);
  }
};
const mutations = {
  setPageData(state,payload){
    state.pageData =payload;
  },
  setPagingInfo(state, payload) {
    state.pagingInfo.totalSize = payload.totalSize;
    state.pagingInfo.totalPage = payload.totalPage;
    state.pagingInfo.pageRange = payload.pageRange;
    state.pagingInfo.currentPage = payload.currentPage;

  },
  setListData(state, payload) {
    state.sliceData = state.pageData.slice(payload.start, payload.end);
  },
  setCurrentPage(state, payload) {
    state.pagingInfo.currentPage = payload;
  },
  setFirstPage(state, payload) {
    state.pagingInfo.currentPage = payload;
  },
  setPrevPage(state, payload) {
    state.pagingInfo.currentPage = payload;
  },
  setNextPage(state, payload) {
    state.pagingInfo.currentPage = payload;
  },
  setLastPage(state, payload) {
    state.pagingInfo.currentPage = payload;
  }
};
const getters = {};

export default { state, getters, mutations, actions, namespaced: true };



// WEBPACK FOOTER //
// ./src/js/store/modules/paging.js